import { uniqueId } from "lodash";
import { useEffect, useState } from "react";

import images from "../libs/images"
import { uuidv4 } from "../utils/utils";
/**
 * 이미지 라디오
 * @param {{
 * className?:string
 * options?:{
 *  title:string
 *  imgSrc:string
 * }[]
 * current:number
 * onChange:(current:number)=>void
 * isLarge:Boolean
 * }} props 
 * @returns 
 */
export default function RadioImage(props) {
    const {
        className = "",
        options = [],
        current = 0,
        isLarge = false,
        onChange
    } = props;

    useEffect(() => {
        console.log("RadioImage render")
    }, [])

    return <div className={`image-radio ${className ? className : ""}`}>
        {options.map((v, i) => {
            return <div key={"imr-style" + i} className="item " style={isLarge ? { width: 140 } : {}}>
                <img
                    className={`thumb no-drag ${i === current ? "select" : ""}`}
                    style={isLarge ? { width: 140, height: 140 } : {}}
                    src={v.imgSrc} alt=""
                    onClick={() => {
                        if (onChange) onChange(i)
                    }}
                    onError={(e) => {
                        e.target.src = images.block_img
                    }}
                />
                <textarea
                    className="title body2"
                    style={isLarge ? { width: 140 } : {}}
                    readOnly
                    value={v?.title}
                />
            </div>
        })}

        {options.length <= 0 && <div className="item" >
            <img
                className={`thumb no-drag`}
                src={images.block_img} alt=""
            />
            <textarea className="title body2" readOnly value={"목록 없음"} />
        </div>}
    </div>
} 